console.log(
    '-------------------------------------------\n' +
    '| Partner & Partner AG - Impact Marketing |\n' +
    '| www.partner-partner.ch                  |\n' +
    '-------------------------------------------\n'
);
